import { useStore } from 'vuex';
import { addDays } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export function useUser() {
  const store = useStore();

  function getUpdatedSchedule(advisorId: string | number, timezone = ''): void {
    maybeFetchUser(advisorId, false, timezone, 'user/getUpdatedSchedule');
  }

  function maybeFetchUser(
    advisorId: string | number,
    controlData = false,
    timezone = '',
    endpoint = 'user/getUserSchedule'
  ): void {
    if (!advisorId || controlData) {
      return;
    }

    const tzOffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    const dateWithOffset = new Date(Date.now() - tzOffset);
    const date = formatInTimeZone(dateWithOffset, 'UTC', 'yyyy-MM-dd');
    const endDate = formatInTimeZone(
      addDays(dateWithOffset, 13),
      'UTC',
      'yyyy-MM-dd'
    );

    store.dispatch(endpoint, {
      date,
      userId: advisorId,
      endDate,
      timezone,
    });
  }

  return {
    getUpdatedSchedule,
    maybeFetchUser,
  };
}
